import * as React from 'react';
import styled from 'styled-components';
import { ClockCircleOutlined } from '@ant-design/icons';

const ShowTimeBox = styled.div`
    display: flex;
    align-items: flex-end;
`;

const TimeSec = styled.div`
    font-size: 18px !important;
`;

const TimeMilisec = styled.div`
    font-size: 14px;
    padding-bottom: 2px;
`;

const IconBox = styled.div`
    margin-right: 5px;
    position: relative;
`;

const ShowTime = (props: { time : string[], sufix?: string, margin?: number }) => {
    const tMargin = props.margin ? props.margin : -4;
    if (props.time[0] === '' && props.time[1] === '0') {
        return (
            <ShowTimeBox>
                <IconBox style={{top: tMargin}}>
                    <ClockCircleOutlined />
                </IconBox>
                <TimeSec>
                    0
                </TimeSec>
            </ShowTimeBox>
        );
    }

    return (
        <ShowTimeBox>
            <IconBox style={{top: tMargin}}>
                <ClockCircleOutlined />
            </IconBox>
            <TimeSec>
                {props.time[0] === '' ? 0 : props.time[0]}
            </TimeSec>
            <TimeMilisec>
                .{props.time[1]}
            </TimeMilisec>
            {props.sufix && <TimeMilisec>{props.sufix}</TimeMilisec>}
        </ShowTimeBox>
    );
};

export default ShowTime;